module.exports = __webpack_public_path__ + "img/jcb.015bc214.svg";